import {Injectable} from '@angular/core';
import {environment} from './../../environments/environment';
import {RequesterService} from './requester.service';
import { io } from 'socket.io-client';

@Injectable({
    providedIn: 'root'
})
export class NapiService extends RequesterService {

    protected getApiUrl(method: string): string {
        return environment.appNApiUrl + method;
    }

    protected getApiSocketUrl(): string {
        return environment.appNApiSocketUrl;
    }

    socket(method: string) {
        const token = this.authService.getToken();
        return io(this.getApiSocketUrl(), {
            path: '/napi/socket/'+method,
            extraHeaders: {
                Authorization: `Bearer ${token}`,
            },
            withCredentials: true
        });
    }
}
